import type { LegalSectionBlock } from "./legalSectionTypes";

type Props = {
  section: LegalSectionBlock;
};

export function LegalSectionBody({ section }: Props) {
  return (
    <section className="legal-doc__section">
      <h2>{section.title}</h2>
      <p className="legal-doc__text">{section.content}</p>
      {"groups" in section && section.groups ? (
        <div className="legal-doc__groups">
          {section.groups.map((group) => (
            <div key={group.label} className="legal-doc__group">
              <p className="legal-doc__group-label">{group.label}</p>
              <ul className="legal-doc__list">
                {group.items.map((item) => (
                  <li key={item}>
                    <span className="legal-doc__bullet" aria-hidden="true" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ) : null}
      {section.bullets ? (
        <ul className="legal-doc__list">
          {section.bullets.map((bullet) => (
            <li key={bullet}>
              <span className="legal-doc__bullet" aria-hidden="true" />
              <span>{bullet}</span>
            </li>
          ))}
        </ul>
      ) : null}
      {section.footer ? <p className="legal-doc__text">{section.footer}</p> : null}
    </section>
  );
}
